import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, Col, Row, Modal, Button, Form, Spinner } from 'react-bootstrap';
import printJS from 'print-js';

import toast from 'react-hot-toast';
import { useForm } from '../../../hooks/useForm';
import { useContextInfo } from '../../../context/ContextInfo';
import { AuthContext } from '../../../auth/AuthContext';
import { fetchConToken } from '../../../api/fetch';
import { AiFillPrinter, AiOutlineStop } from 'react-icons/ai';

const ModPayCargo = ({ show, onClose, data, callBk }) => {
    const { setResp } = useContextInfo();
    const toastId = useRef(null);
    const { auth } = useContext(AuthContext);
    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, reset] = useForm({
        forma_pago: 'Efectivo Oficina/Sucursal',
        folio: '',
    });
    const [pdf, setPdf] = useState('pos');
    const [send, setSend] = useState(false);
    const [folEx, setFolEx] = useState(false);

    const { forma_pago, folio } = values;
    useEffect(() => {
        forma_pago !== 'Efectivo Oficina/Sucursal' && forma_pago !== 'Efectivo Oficina/Sucursal 5512'
            ? setFolEx(true)
            : setFolEx(false);
    }, [forma_pago]);
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        if (send) return;
        setSend(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            if (pdf !== 'notprint') {
                toastId.current = toast('Generando PDF...', {
                    position: 'top-right',
                    icon: <Spinner aria-label="Default status example" />,
                });
            }
            const dt = {
                ca: { ...data },
                forma_pago,
                folio,
                id_agente: auth.uid,
                print: pdf,
            };
            const re = await fetchConToken(`usertools/payc`, dt, 'PUT');
            // //

            setResp(re);
            toast.dismiss(toastId.current);
            if (re.data) {
                printJS({
                    printable: re.data,
                    showModal: true,
                    type: 'pdf',
                    base64: true,
                });
            }
            reset();
            setFolEx(false);
            setPdf('pos');
            setSend(false);
            callBk();
            onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Pagar Cargo</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        {' '}
                                        <Col xs={10}>
                                            <Form.Group className="mb-3" controlId="validationCustomrp1">
                                                <Form.Label>Forma de pago</Form.Label>
                                                <Form.Select
                                                    value={values.forma_pago}
                                                    name="forma_pago"
                                                    required
                                                    onChange={handleInputChange}>
                                                    <option value="Efectivo Oficina/Sucursal">
                                                        Efectivo Oficina/Sucursal
                                                    </option>

                                                    <option value="Deposito bancario">Deposito bancario</option>
                                                    <option value="Trasferencia bancaria">Trasferencia bancaria</option>
                                                    <option value="Deposito bancario 5512">
                                                        Deposito bancario 5512
                                                    </option>
                                                    <option value="Trasferencia bancaria 5512">
                                                        Trasferencia bancaria 5512
                                                    </option>

                                                    <option value="Oxxo">Oxxo</option>
                                                    <option value="Mercado pago">Mercado pago</option>
                                                    <option value="PayPal/Visa/Mastercard">
                                                        PayPal/Visa/Mastercard
                                                    </option>
                                                    <option value="OpenPay">OpenPay</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustomrp3">
                                                <Form.Label>Numero de trasacción</Form.Label>
                                                <Form.Control
                                                    required={folEx}
                                                    type="number"
                                                    value={values.folio}
                                                    name="folio"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>{' '}
                                        <Row>
                                            <Col>
                                                <div className="flex items-center my-2">
                                                    <input
                                                        type="radio"
                                                        value="pos"
                                                        className="form-check-input"
                                                        checked={pdf === 'pos'}
                                                        onChange={(e) => setPdf(e.target.value)}
                                                    />
                                                    <label className="mx-1 flex justify-center items-center ml-2 text-sm text-primary fw-bold">
                                                        <AiFillPrinter /> Recibo POS
                                                    </label>
                                                </div>
                                                <div className="flex items-center my-2">
                                                    <input
                                                        type="radio"
                                                        value="recibo"
                                                        className="form-check-input"
                                                        checked={pdf === 'recibo'}
                                                        onChange={(e) => setPdf(e.target.value)}
                                                    />
                                                    <label className="mx-1 flex justify-center items-center ml-2 text-sm text-primary fw-bold">
                                                        <AiFillPrinter /> Recibo Normal
                                                    </label>
                                                </div>
                                                <div className="flex items-center mb-1">
                                                    <input
                                                        type="radio"
                                                        value="factura"
                                                        className="form-check-input"
                                                        checked={pdf === 'factura'}
                                                        onChange={(e) => setPdf(e.target.value)}
                                                    />
                                                    <label className="mx-1 flex justify-center items-center ml-2 text-sm text-primary fw-bold">
                                                        <AiFillPrinter /> Factura
                                                    </label>
                                                </div>

                                                <div className="flex items-center mb-1">
                                                    <input
                                                        type="radio"
                                                        value="notprint"
                                                        className="form-check-input text-danger"
                                                        checked={pdf === 'notprint'}
                                                        onChange={(e) => setPdf(e.target.value)}
                                                    />
                                                    <label className="mx-1 flex justify-center items-center ml-2 text-sm font-medium text-danger fw-bold">
                                                        <AiOutlineStop /> No imprimir
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModPayCargo;
